// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"28":"8371a1d5","331":"ff9ae819","382":"a3f912c7","396":"fd8cb28f","428":"731af15d","463":"2bfa7f53","670":"da5dca50","772":"22285f26"}[chunkId] + ".js";
};